import colors from 'tailwindcss/colors';
import type { DefaultColors } from 'tailwindcss/types/generated/colors';

function setTheme(colorValue: keyof DefaultColors) {
  document.documentElement.style.setProperty('--theme-color-50', colors[colorValue][50]);
  document.documentElement.style.setProperty('--theme-color-100', colors[colorValue][100]);
  document.documentElement.style.setProperty('--theme-color-200', colors[colorValue][200]);
  document.documentElement.style.setProperty('--theme-color-300', colors[colorValue][300]);
  document.documentElement.style.setProperty('--theme-color-400', colors[colorValue][400]);
  document.documentElement.style.setProperty('--theme-color-500', colors[colorValue][500]);
  document.documentElement.style.setProperty('--theme-color-600', colors[colorValue][600]);
  document.documentElement.style.setProperty('--theme-color-700', colors[colorValue][700]);
  document.documentElement.style.setProperty('--theme-color-800', colors[colorValue][800]);
  document.documentElement.style.setProperty('--theme-color-900', colors[colorValue][900]);
}

export default setTheme;
